import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePayAddChecksPage, { getDefaultData } from "components/pages/TASPositivePayAddChecksPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayAddACheckPPAddCheckEntered
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Add a Check" capture group.
 */
export default function CapturePositivePayAddACheckPPAddCheckEntered(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    defaultData.checkForms[0].checkNumber = "1040";
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "checkForms", ], defaultData.checkForms)
    .submit();

    return <TASPositivePayAddChecksPage data={ data } />;
}